export default "__VITE_ASSET__lvJf9u6h__"